import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './Tabs.pcss';

class Tabs extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.node.isRequired,
                content: PropTypes.node.isRequired
            })
        ).isRequired,
        activeTab: PropTypes.number,
        setActiveTab: PropTypes.func.isRequired,
        tabRef: PropTypes.object
    };

    static defaultProps = {
        activeTab: 0
    };

    render() {
        const {className, items, activeTab, setActiveTab, tabRef} = this.props;

        return (
            <div className={cx(styles.wrapper, className)}>
                <div className={styles.navContainer}>
                    <div className={styles.nav} ref={tabRef}>
                        {items.map((item, i) => {
                            const itemClasses = cx(styles.navItem, {
                                [styles.active]: i === activeTab
                            });

                            return (
                                <div
                                    key={i} /* eslint-disable-line react/no-array-index-key */
                                    className={styles.navItemWrapper}>
                                    <button className={itemClasses} onClick={() => setActiveTab(i)}>
                                        {item.title}
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={styles.tabContent}>
                    {!!items[activeTab] && items[activeTab].content}
                </div>
            </div>
        );
    }
}
export default Tabs;
